<template>
  <div class="technology">
    <!--PC端banner-->
    <div class="banner">
      <img class="bg"
           src="https://lambor.oss-cn-shenzhen.aliyuncs.com/banner_science.png" />
      <img class="bg bg_end"
           src="https://lambor.oss-cn-shenzhen.aliyuncs.com/banner_science_end.png" />
      <h1>弹指间,帮您快速搭建产融科技平台</h1>
    </div>
    <!--APP端banner-->
    <div class="m_banner">
      <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/7F1423BB9311402B.png" />
    </div>

    <div class="main">
      <div class="w"
           style="padding-bottom: 50px;width: 1170px;margin: auto">
        <img class="bg bg_title m_bg_none"
             src="https://lambor.oss-cn-shenzhen.aliyuncs.com/science554969.png" />
        <!-- <div class="mask w">
          <h4></h4>
        </div> -->

        <div class="scienceMain"
             id="scienceBigPic">
          <div class="content">
            <h2>结合前沿科技及行业洞察，持续输出创新的科技产品和服务</h2>
            <div class="itemBx">
              <div class="item">
                <h5>智慧风控平台</h5>
                <p>在风控初筛、客户尽调、风控评估、额度核定、在线签约5大环节形成ISO在线风控管理体系，根据模板自动运算模型，输出等级和评分，实现全生命周期风控保护。</p>
              </div>
              <div class="item">
                <h5>供应链服务SCS</h5>
                <p>以供应链服务为核心，打通产业供应链全流程节点，通过整合数字化供应链产品服务，构建全流程数字化供应链体系，借助模块化集成式解决方案获得灵活性和可视性。</p>
              </div>
              <div class="item">
                <h5>保理系统</h5>
                <p>通过产品管理设置产品模式、融资规则、关键风险控制点、流程场景、签约方式，实现供应链金融的全流程信息化、智能化管理，系统涵盖贷前管理、贷中管理、贷后管理场景全流程控制。</p>
              </div>
              <div class="item">
                <h5>客户关系管理系统CRM</h5>
                <p>从商机线索、客户跟踪维护、客户立项到合同管理、客户分析，售前全流程可追溯。</p>
              </div>
              <div class="item">
                <h5>B2B服务协同平台</h5>
                <p>实现客户从平台注册-企业认证-产品申请-电子签约建户-在线签约-在线下单-在线确权-在线放款的全流程线上化。</p>
              </div>
              <div class="item">
                <h5>资方通</h5>
                <p>以“优质客户推送+重点数据分析+智慧风控评估输出”模式，助力资金方更好地评估、量化、防范信用风险。</p>
              </div>
              <div class="item">
                <h5>平台门户</h5>
                <p>基于云服务模式，将产品、服务、方案、客户、能力、伙伴整合为一站式产业互联网智能运营服务门户，满足企业个性化、专业化的互联网对外展示能力。</p>
              </div>
              <div class="item">
                <h5>供应链金融ABS平台</h5>
                <p>通过ABS产品/标准化票据产品规则创建、产品设计、产品发布，实现客户从ABS产品申请、资产审核到ABS资产组包发行的ABS资产化业务的全流程管理。</p>
              </div>
              <div class="item">
                <h5>数据中台</h5>
                <p>通过ABS产品/可视化呈现企业的关键业务和场景，智能预警，及时查看业务变化，构建数据运营模型（推动业务发展）和构建数据决策模型（价值分析）。</p>
              </div>
              <div class="item">
                <h5>底层账户平台</h5>
                <p>建立统一的底层用户/客户体系，打通内部用户/外部客户的连接，实现SSO单点登录精准用户分析数据，帮助业务、风控、运营、产品等部门利用数据进行精准分析。</p>
              </div>
              <div class="item">
                <h5>底层信用平台</h5>
                <p>提供全生命周期底层信用数据服务，打通产业链供应链的数据壁垒，从业务视角进行全局数据资产管理，通过数据驱动业务，实现数据的高效流转、数据资产的沉淀。</p>
              </div>
              <div class="item">
                <h5>多产业架构平台</h5>
                <p>基于平台门户引擎+SaaS服务模式，根据不同的产业集群构建多产业平台门户，提供个性化一级域名访问界面，展示产业专业化品牌形象。</p>
              </div>
              <div class="item">
                <h5>九牛星图</h5>
                <p>酷炫大屏实时呈现业务数据，满足客户运营、领导参观、运营效率、业务监控等需求，新一代敏捷BI，让决策不再等数据。</p>
              </div>
              <div class="item">
                <h5>跨境三方通</h5>
                <p>覆盖亚马孙、ebay、考拉等主流跨境电商平台，以可视化数据的形式呈现各大电商平台产品销售额、销量和价格，交叉平台/品牌/店铺/单品进行分析，并提供定制化报告。</p>
              </div>
              <div class="item">
                <h5>超级API开放平台</h5>
                <p>以开放、共享、高效、直达的API开放平台为承载媒介，提供标准化的对外访问接口将对接/输入海量外部数据源，嵌入到产融科技平台和业务流程中，实现产品和服务快速创新。</p>
              </div>
              <div class="item">
                <h5>牛6CRM</h5>
                <p>覆盖销售、营销、服务的客户全生命周期移动化、数字化管理，360°客户全景画像，高效识别、管理、分析线索，订单、回款灵活配置，无缝对接ERP。</p>
              </div>
              <div class="item">
                <h5>牛营销</h5>
                <p>用于业务员、渠道商、业务经纪人等多渠道云营销管理，借助智能名片、产品码、服务码等营销工具对渠道库里的商机进行有效的互动与营销。基于微信移动传播，实现分享推广返佣分成营销模式。</p>
              </div>
              <div class="item">
                <h5>企业牛社交</h5>
                <p>汇聚微信、微博等全量的应用场景，拥有核心行业数据、营销技术与专业服务能力，精准定向瞄准活跃客户，多重推广能力高效实现您的营销目标。</p>
              </div>
              <div class="item">
                <h5>流程审批系统</h5>
                <p>对接钉钉、企业微信等平台，提供预警、协作、移动审批等移动办公体验，无论出差还是度假，随时观测数据，随时随地掌控业务动态。</p>
              </div>
              <div class="item">
                <h5>费用报销系统</h5>
                <p>从全流程驱动到全面的集成功能，将多管控方案融合，助力企业以智能化、平台化、全程电子化的报销和费用管理。</p>
              </div>
            </div>
          </div>
          <div class="demo_icon">
            <a href="http://iportal.zhongpukeji.cn/"
               target="_blank"><img src="../assets/img/technology/demo_icon.png"
                   alt=""></a>
          </div>
        </div>

        <div class="app"
             style="position: relative;">
          <img class="bg bg_title science_bg"
               src="https://lambor.oss-cn-shenzhen.aliyuncs.com/scienceProBg.png" />
          <div class="science_bg_box">
            <div class="item">
              电子
              <br />
              签约
            </div>
            <div class="item">
              人脸
              <br />
              核身
            </div>
            <div class="item">
              OCR图像
              <br />
              智能识别
            </div>
            <div class="item">
              票据单
              <br />
              据识别
            </div>
            <div class="item">
              企业四要
              <br />
              素核验
            </div>
            <div class="item">
              增值税
              <br />
              发票核验
            </div>
            <div class="item">
              电子围
              <br />
              栏预警
            </div>
            <div class="item">
              物联网
              <br />
              智能视频
            </div>
            <div class="item">
              企业
              <br />
              360画像
            </div>
            <div class="item">
              大数据
              <br />
              可视交互
            </div>
          </div>
          <div class="m_app">
            <img class="m_app_science_bg"
                 src="https://lambor.oss-cn-shenzhen.aliyuncs.com/73C49FCE7E2CEC1B.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'technology'
}
</script>

<style lang="scss" scoped>
.technology {
  background: #160f00;
}
.banner {
  display: block;
  overflow: hidden;
}

.banner,
.banner .bg {
  position: relative;
  width: 100%;
}

.banner .bg {
  min-height: 312px;
  float: left;
}

.banner img:first-child {
  min-height: 514px;
}

.banner h1 {
  font-size: 60px;
  color: #fff;
  font-weight: 600;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -35%);
  white-space: nowrap;
}

.banner .bg_end {
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
}

.banner .bg_title {
  padding-top: 175px;
  width: 100%;
  position: relative;
  bottom: 220px;
  left: 0;
}

.main {
  height: 100%;
  padding-bottom: 64px;
  position: relative;
}

.main .w .bg_title {
  margin-top: 50px;
}

.main .w img:first-child {
  position: relative;
}

.main .mask {
  position: absolute;
  height: 200px;
}

.main h4 {
  width: 400px;
  height: 100px;
  background: #160f00;
  position: absolute;
  bottom: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  font-weight: 600;
  cursor: pointer;
}

.main h4 a {
  color: #160f00;
}

.science_bg,
.science_bg_box {
  position: absolute;
}

.science_bg_box {
  top: 92px;
  width: 1170px;
  height: 470px;
  padding: 72px 68px 98px;
  box-sizing: border-box;
}

.science_bg_box .item {
  width: 132px;
  height: 132px;
  float: left;
  margin-right: 90px;
  text-align: center;
  padding-top: 33px;
  line-height: 30px;
  font-size: 22px;
  font-weight: 400;
  color: #c69d4d;
  overflow: hidden;
  box-sizing: border-box;
}

.science_bg_box .item:nth-child(5n) {
  margin-right: 0;
}

.science_bg_box .item:nth-child(n + 6) {
  margin-top: 37px;
}

.scienceMain {
  position: relative;
  margin-top: 80px;
  margin-bottom: 30px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABJMAAAdMCAMAAAArLTjRAAAASFBMVEVHcEzt1pZrODaKYEm+m1uqilatiVprODbGnU/HoVahe1trODZsOje+m1nWvIBwPznt1pbHnk7z3JzkzI27nWHYv4DFqGzPs3a8BE+nAAAAEXRSTlMAfnP+cv4d/rNL/ss/1bqcyG2l7zMAACAASURBVHja7J2JmqsqDICLCxa16CdF3/9NL4R9UzvT2e6R9kxbZQ3JT0Kt53a70pWudKUrfXvCxP9EEMHf2DiC9HqLGKF5XvA1e59NBCaA5CRMzlfygQkUDc8LuibgShnlWALNWCDN39W6ao68WAotHyvnpRkqeF1WBeksuep0N3+14aFMF4nk/QvSQa/ry/LNenalv4UkXzXQKV1Bp9PXMMmoNNp1pLIJn2QSrOOxJ/avMGl5pePkI3Axq8o5P/ozGnalP4ckZZvG9rTRHQVFutCJdA4uLyvWfIhOVOgQ2WUShlBmduNDX84k1WQ+fnprfIayUXmOSXZ+X1CgF6cQn/R0509r2JX+WppDW91VAfI6kw6XTwbZmhd7XfWHCnnEJJYrXxgAnlHgQLyPSSTs5ldwCQWTNcd7dzkmjfcXYuPl3DIWpYGdQ9nFpH80dLPagZY3M2k5xyT0qgP/tCYWJ3LAJLTHpMy4sHIFZvwFTCLzl1sYKgpgj0ndC9s95ETeNJB+cNOd/WDsYtI/yKSBO+Tg5d1MYm/xk84j0FlXiUnNHpNQrj4dnRBnf/Q9TEJfbmF4Xl5g0tkVKVKg5/HuE3lhApeMflxM+pfS0HWbVan5nLn/CSY1PJ9295P6pP8bsnaNTvpJbsWfU2fuKLr8Iif4DUzCJSZ17DDSwx9m0uUn/XtpFFCChW6dDnTSJweNLV2rJYuPbz/GpKrLp9FvOEbm5NfU1zI/dmJB5/yk+dz+GvoQwz/rJb3dTxKBXn24pfRpP2lt03Qx6f8bvHWdmN6168zGZtsdmDN4V11Xe6fWtGgv/ww/yaQ+1WMxCLRDiqpt+75W3hJTw6hu2HpPc45Jsb2dZBIOvDG+sfczyRupWCw2Hu3dJc7Lx5h0m8zsl7eUyGf9pDqjjheT/iduUZPTqa4XSHpI1RX/tu6YSaKI8K74HpP6hdenmMTOMYnpf+Zv4F14L8g6gG6nzKVhUExi8sn0q7OlEbpeOyYNUyWgXZvsSLURM4l5T8kkFjXA7PvZB4Y+3WuJ1S17L5PMOJfNmHS/xkzyurrQoNtOtupJduJ/MzFoh0mHE2j+BCX5x5jUkMvW/0hq2ia70AFDlOXw7gyThpqLvOtgElWlH/bAINSL9cN0wk9ih0x69H0rHvBky7MP06qPQJa+8VHGoscCMLCIMPZmGYM7TxTV6MTDITshqlTEJBZA6caXBEr2PY86J4TkS7jnb5xsYpoPHN/VYxILudmAK/k00hI+o+9ikpIfRkctMTGYQvRG3ASK6eLRBPZCU2yGto+YxGTVU5Um2SYrMaltLmv/E2Havc1PlYhzBuav55nHHKsj89dFGn3G4Czob9CP/CR2xKTBWpREYezIiYZWt45WgXsVj8p13R+pG5tQ9XFsbF7nPW3iSD3kmNREApNmVHw45jB9SHpJAHHV/beGbt4q41qoQpgybdriCWuTDOThY63kXacrUlCBnPRJM7v43dvoZuspckZeT+s5i7EIdMWkqDqswKT2fv0Y8g8gSa52TboRKua7mqjTz7w1hfu6SOViRleo+mxVcoaKGJsPmSQLsgMmTXaRh1aegUY/oSFLJY9J3B+K+uO67o7FvL01Nq8PJWlJlSoSMslWo54eQVt1xrM3G8ti04na9nishvcySXdp6wbDk2ryBIR96ch/IOZavV+UkLmT7JhtADQDy1KyEno7YFLPoPoASjVMoJNSyCQl3Q8wqW0vKP3+uK19ZFzamSmSzEoztIamaU6KQWZsmASlkEMW1HTsJ3GwhwMmGW+d6b7dPQ/+brqsD46+PntA6KFHpm99z5l9dby1MmBWCvaLAGFHI1GnYybpMqqIxyRtgXkm6dT7IqqS/TeEqBI/zbsg8ld5KkNyDTjVneKVvwRNzk/yZhe63kj5baqQcEbFhweceULk5PVzVo3pkVPpaMuVYau70gUDbrKgKe7HYJueQXMwYhJ0jWZ+6OZPUCZ2e7RX/PYX4jbJJBwrrtBnfBtr7mC0REu/fNIo2tPZNXWoKoWstqu6hmMmQb6TykNM33AMR4fDuO42WI0Nk8ADWPQro6HXtviUuVkoCU+BZNwB5QOoIrDMR0zK+0m3go8WAmm2vFhyQySIefRk0QpgjJaVrnbUYlmMlLBXqJZ+EclXgDUEGyUjqra5uRym3j8ktOAxmQHRTDdxST9Ky6Q6nhsZKPoVv/1yJD1gk1JMFWkzejvjSWqndh7UFUf2WiO7GgZM0h63Pk59MNgFuO6mtzIJPxL9NRq94ULdm95bXSMmbTBSeE38JD/JEhRLKDkj3WfSDZukO9fYA66TmDOWE2zqi5Z9VZR0NoDHne1DCcfYxM596+XM4TnbrJECcn6SvEjJBs4YUJqnQcXjJcQ6jM2OfuylTKGWQEBARGRwQek3x23YhNnJigdqO3R92xmUgK6ajYQ1ZzpD1/ra5TPJhSXdm/2kQW8eOTMx+OO5/Q6eJ4yKHdRJ9brPJKSsenRDO2BSDI1c1IWfjjSkvNcWJXrApIAEkzuMikxaAyYZCj3BodOTyqZbloXEYxJs+anZ3hm0XMp4xEnqlOV9TNIbp/iK335tst+3xUzyluvGWVatl0+ugo4txyRsjivt8phk9Frq+fEq9RKTxrBR1xbPemRbmUn6pH6lexRDqQcYygIcII0E6Qq5HQ8tFZr8QFik2vd/yEkmhR5Ps7/rN61sn0qu3wwpJ84Aom0pom4eq6z/1vhMwnZRQHuh2GAcM9NTk7stKMv2GSZd37/9KseIJHHbDZzZiEmTWLdkmCa0Uhj8pN4PQw2HGIcLkDbGMyHGCEuefM6gzFAPUpiAE23OdckwiZ9nkrxoAQpsxC6y0FadXWQ3PTT7DJnES0zy8oshqZFxisFPghOZcEud0CbL9cNVpT97BYWHwt2JLJWggmff13W/6vrmxF/ZWnm+NR326qlq1wU5NznbbPRp9TPA2R+4LsbWRLZaIlXjS2MMp5QXfDPpX8taH8ZRVw0+S8qy6W4kq4WdpAKTnMr78Ru53Kaf2j3yv19r7Kzc25hJWLlBylqqiSgTkRsnWpNnvVRxntjhJJc8Y2lUqTByFvk8haSbynysKdTaiDF339q5VVGa6rP/0GbIzUnFJlvIXF0AmdUHIwnYQdYCyjHJVG+GZPvlP5AvPo+WIuPcZGRjL8CWkTJkwyFQWpOh3tR56k9uGwqA4syWlRannDrCMj3niQOjhbCOTVYak2k13hjnQfXhBNpuxJtfj/4olZjU3u2K7BvDBaUf29BukrhNHk38JICS/K0s+OdEKeMo19gNtESqozzP+D3jh68qv7BWCnm4vLGHOrZ2scefT7IZzk8wiSszMcbCVYOelquPNOhgkqR3IYvCqJh69QqpTLoqXWLaTEPECCjDJJ0DUU5CEpnCsflKP9M7Lfkf+0qbfxmPmg8e3FjAv1Cr1lIIt99c0/CMfRfitY/MIPwOcxEVVyTsGVK5etxkpVF1PO2q3CWI58s74EmK40jJjlKRSWYpbgyeggX6St+ZiHdtZBy3xUyCL7lXrvdjwFz5imHf9ineTthig2b2SGvIL6+woUrLZOz2hDq646/cNJOkIh4zCTk1Nl8HRncmUC+umwS16aKKiMcky6aQSb2useulzU8gH2iBShvmWVncXD/wxjM9Y0nBQa0GfoqQAb2Z5JXllQh50iyV/kWeOD9JkkIzONh+62NB4QzpdaL4kcpTfk8RNatvClGb28HE0gDNEWmOmcSzMxZKiHHyNiZl4rcm/yuZK335hraVexK3JUwCKD3rbmjknqy6v4h4dxf2u8m9DPFeWQ5N/8ujSqr8Cns51FrMAAfPIkmj4ZyfdCZRj2L58ymT+COLFyTNFPDcmqpx1gpxg7zuJUzK9k65qO3Oecmkwfia+P5McwgmTeY+6qTPQEdkqNfC/aMynFj7pMOCyphGU6RPTSUmTXWmKYPz4xQSozpMe0xK4jfiHb3S9yJJTQExF9jbuC1lkroccBCa52zJt6qtqC4QHPTqO2DLJLjieT1xQ4AvYtLjkEmNuq3Txt1reF12kB2uTAJ3Y5XXTGasMO4ZAYds44GXps/d47g5plJQs/xJiOQdLWSoJJEIQrRo0hPsNIVN4HLX66fsdF3XHpJGFJXTMlirEpOwcSzpvp90xCSSP0kOOeYxySzJZpVu2gtKPwalJvSTSJlJYHTY188tgyP4QBLtMxfK6dKNtoPTSHqVSZt+2DfBB/Gkp5gUDeyRsx3VM3ktJkDpKQd1hknjoLyT4F5SusopXQ26fiu6MRh81K3sSREan4/dDNhqeuZriDCxkclsTRnHSUyuEVcTMbsfS0y6TTmfjTixmmc0jfpB9ijW5JnUFJlEQj+puZD0e/aTPE8pLSEXZAoK4ozc0xL7iURWaFkgMkAm7+jJO03+x96ZKDmu6gDUw+YNxzVVNP7/P31GEjtOQu70TPpVcHcl3kAIdCwwELz4MZMmiNc87F1YU3/nqKv8dh6P2aLtlnVchfOQDfeyaofZbmfUGlVzy3u68hQU9P0cX1887aCGU3Kv3l0CA2wUKY16PlLmevkTZt2uyyj0KWGHjEzsf05oeoTbvw6+MgIoHXQt8Jl2DEvvOjeOGi61gf1YFEHaC6XxEH9Ygjqh2HHkf+QntQ43mRQeyJ/+pDd67xbXJ5kumXQTZ4nZA7lC4SvuxcKnSG/pVV/05Su5PkZzhvuyQrLHE34SxCwf1uho9b+cJIYnwYl1MinJIUmdGLqK+eL49UbuxoqUcGfQCqmaT6m2zMIV8ymERX82irR+FamISlEWlWQg1SqlcWuImhVXZXAMqWTCNb8i8kLki3S00PspsvFHXQt89jtxRACld6pDHKVI/hknKeoSsEcXk0r0nH8CUm0dbjFpqt67faab/MP2W2N80nzVdjuryk24bgSsY+4bXw749EePQ57ftOdDBp1irzz4kElfzzBpg+tkj58EtsZdB8n57D/D6KTaYp2OEN0K9pFJQs5v1AZaUVVg2Nuv2y3kbEoyTbPGbhj3rTD+pTVUWaFzYn0Uc2KSGAzmAHcKUSEHbtTkOFKGGk6AxkX7fMHcsgQQQQssewC+V0gWkYQhrqhCbDG70zAkX7eEGC8zE3A+djGpCmIIz5TicINJc/mAdsbwabf9s/Zbaxw3td/Ka4WvdmM0LLARms+O5rLE6rIdPeHP+EkYV0+F+oVMAtE5MObI/KQkbKUuSA+nGUucxKV2IRBESVDxFhNV55pkdMEt8WecABfvIp0nwyvzosT8rMOKSd5k/aoD9mj7ScEdk0WJKAReVrox/zJH0pqp9bxBh4sbIyO8MLeqlumOOkwKMBBKJpWHKyZV7TbY/QyZfJ9u76T91jRe56nzaFgWiz2p7PxFJtl/xSSouxNzIjDnywiWMIlzyhX4hHvr0Wzd8B65LJsnkT1si0nMLhHnq1u/iXlNwjqzKhr2ZatBu7YVhl9Zy+wIjkXFpFuOpPG4wySgEi+YpEEojFfsrnCjk+SiXUWyo/ICO7gKdJiyTvcZe7krVohUZz1M4rF1mzKpPFwyKbbbPm21twxX6wIQYpy1TYwJ+GLZ+c2iBVrXJWL9eb+s10Yn0UzTLT8Gfw+Z5LaHTFIYpehikruBOWFPW7OWuTiASdYB2LgPmzf4FEpjMDFHCp7CqMztHF9tjXiR7085fRKfMbXR12Iq61y8gjNHrgoqDIOjItWJIIvy55pzbpQbVuk1lDBJqbJBRbf4A8ZFP1GqOiRJsa5hN525SMnYNYiYMckBQ7hBXU6NPJ1dhPLbLiZ5UQA+kJYIUpaHSyZ91gX4Cd3esH7StMk2FrgekEQGJpsa62qedc63LXGw8ypIvGipz/AHTHqONcLChXtHln+BrbHxvPG8++ArZHSDXDomWc8kzj2TZrQ3jh+AG4sJ2/B5hE+yBFirZPW3oLZd9Gg6t42uN8X4CJs/v7W1OXYFHpC0bq2i81uhudBvTo8ROyc6y7k30RXGS3kWGl+Fz4q6xcy5lwX+8iObTE3JLCx+nzKlnzEcN7FK+HW8PS1o0EIPkzB6+s0JFEx4xVSHMyZt02f9pB8ApbDOpKiKHgJHw7dQZdU6Lq4STVSbbFbsjfH+Ei9anhv7nzGpiPyi9YlYYB05htyIeTFoDcsEaW3o1zBmIGE2ncywOpNm4SiUo++OaA5Y8h+J1Hrdtc9H8EkQZumd5ZRkd3+yxNvmr2ep+NGIJzq9FZrzqlNespRJ9jYX+oD8+SPLCUotKJbZEpKs84vGffMRymzmIskBrzsoxqkupxsrF0cn+ZaePlHUn0hrqQipivqamNXPOpM/p/3WmhZNJNr9N0nPfu4Qo1vY2GvwLK8yyTzHpMJgn2XSIaaIkJRJZwMUj8F5lXgOJz0ikwZtbCO4EQbFqvk5k04V8fyWarINIGATYlZqFlNgnSmYRKoJ2aiYhMLPIaG5KNhJzLOaZxGgZ4Pnup5u0uCZFJMAB+dKcsWhqNehzSRKRbjRtCuratkLTLJPMKmqP+qzHvcPcZWav1sy3JBELKmVF8Hbg64D1cWpcepPMImq3qI7mWQfMkmkdqw5mKSIgFHkALpJF64hGlyH4idSSiadvmQGpXqBp9rtig5I5tac3BJ1GZwNlOCuiTSXc+0YFUANkuxy1JFJWoa8rVlNyGDK4Mcx8a1Ag0nWHwLnsapldv87TPr8bsmPCc3fdyNbUM8zqdm2es7feZFJonjC/xcmpU90M7As+dXZJItt2GHg6BKFH3NK3cF7TFKhPUs3qGbGyxCHMLHiAlOWAW+ef8yk6PbAoCvPJA0CG5dZvuV3pN1SezKISFTVQtkL9NAJ8xeZ9Gm3/ZT2m6hL3rhtBTM1uOFf/u3c7jIJLnmFSW57dB8JsPYxyQCTgvwQS8Ikl7dhzzK2y7OpAncaYlLRd4ZnNubehNUSpu8Yp6i380StmVK5sMnoTjHu77VwhnZjGawmu8BfPmcKqLb0ZZh2X4UvgB3WhzjDhhFG4bPiwQGYWQKqTLJGD51YWBeTkjoVd0T78MOK/glvGnRderEWGWMvt2ilbSY9x5YGk55h2Yyxy72LSSDQaUGL++LsyGRMgpQFfgT1cPfGnlSS+gXr6kZFaBKkHialklsw8Up7QjVgnGNpGVNgLP4C9z9yUzJpNMkFfKSdOZWhLsZ0pLvag6Rh8rRLx9CN8cGUZ1jve5bJOHODDsgKPahmw3t8lznmz0sEflJ++IJJnzltPzhsULBQi86P7A8/qeDP7/IekyC8wqQn7kMZDWd9THIRA5OMs8UR0tpmIaaNTCRU7Tm2uFa6kwisM5dIoyBTy37CLYMSJpoMac/tT6mh8CVqFsOSvzwnweGCxe8kTGIeH+j9rLQT02DcFEEWPfOa0E0F4IaTy2jx8mzN+finK+qTQoQLm9+v0DPTmS5H19+UIkgkqdp44uMU3bGD398Uvk/pVKfVcLWmH9Xs+wuQTGh438MkMngzql4m2ZRJgJpNeEKkxIgdStCcweMtN7NhocqZI0UJ0k4UPaWTPNBTLMHAqEUGWvByiRfXm4znFxgXCbMPlwxagBCPGpicuHCdd0fHFBbe/IltEQtArUuiFrhcovi2CSWWZ9P63NZtbHyoWL73MSkP1jOpDh8mfR96/kDonGNIBc+pkjeQJJ9k0vf5SeQmLevQy6QzYqVANorj9JMaVTpaHNuHe0yaG36SSuKpLEYG/ZXW09J17gemQy5WmqqbloHOby2nsNIA82KKsh4umaRE6VKt3lNq+oaDlqYZqja21/mo/wuTzJ9j0vTGBvya/yEuR4f+ez9JTVO/5VItWpNQVjfpDn4Dk+Tj+0KNZq8wiWQjAeXUqtKxRaSG4ZGfVNnnFpVUGhJPHM2i6aWrUV57Wav2dAUWVq7FEtZGIhJVTFKsdHxXdlUBRJYPQ8uHqgRKjTqveZtJVRt784Ae3oNJ0zu/k1PbC1Ca33vA+tQlXtKd1KiqST27H+l3Mokil31Nt4JJPj87K1grQQLVyPuTTNKxwbNETQQiwYjScCgbtaPZvvoudNZyIRScx6E+urX8NFIHUUPns5yokIKbNaeuH0o4OywlEjwBIpRag33U2IRSPdeYXMmxq+nmlS3lcm6yZFJ5uMfo33u9ErV1d9DPv9984IPogJKrLWe5ct04IdPtwSNuwnheYtIZ+/37Vu7i7qzRBZPAeqRZkEnSda/QwCOe9wzTndLICzM5z+R1mvs3Ak5JbDS0s2CbC52ZhRLt9PX+Rm0ByYBJO0nOk0YeQUk2G+4rtEyzeuI6v6pL9QhnOh8qM5YUkR3T8UyKh6UX/1v9kL8Lpd9zL5Le/jWjeF5EtbtOUFkPRswbb/zRAttTf93wTJKPnnMMuLH0dUa4ukuQhAVadlelT2tjOh8ECf24heBw5wWTZN12W+n1JNitHgFRJulQZsFXkuP6fpUlFMAKeMZfsWQJd5yC4IcganVAR73reqcNVatrdjmw9WZe46tf/+SQwU/KDvc+C+ff798h3skY9fsHjHzoyJN7/8tlXVsYl/DDG5wGMj94vtNSAewFJjk3/H41ccthd9fogXmBoFvGd/hqVXSxrDCFPZ+jf7mggcIzucfGlkWiknZIjTyNqDO/wK3kvVz9O34SOapqBRHHgj8OKG0ktbvRG1UFfo+q+6GiQwm5EOK+OPz/41L0tsVeaOu9dT+ZvipTdbWk7CU2+upG4ic9fs7BGv295sy8QCCbDvnw3Suw6pBXAWsopaXXuqM5ff+l8BJedVn7Du39/arKHgtOt9/NreMVklpQWvWV3nofKjrttNclk/T9+vsH+jX+KZSel/P926K9/Xhsb3rbxWClffhGJpnHE7jZC+YcmQSvDBFEA/QF59n9r0wacmtkzZdoSKU3NAiWFJxuvps7/af1WnD9P/butqVBKAzA8BA7KCri//+zpYMkppvW2s6j1/UpokJt3h7fi35WFCs/OB4sb5/QpHb125tUYZ6ntDmeYZI0Lv7NJxfafmkLVkxD4/57OPHgb1xP+uzfNRnPe214qESxf3Vuf07Q+u/fnJFqV1+wmhZns5/uPGnnmjfLv9sUl7ybdFmexNT8fU1OTR9pnYgTpS7S9aIxtglTkjbcMNnGWfBtoGl94VJ5+6cx92sAbqJ0tMxG2Xf+mAZK7g3g/5MU7FO2JTdVtFdDRTjHcD2RZWSBlWF/cKoq4P8h+01Ds+sYJfxyp2EI+PSSR8nZtntnvKpJZJikmC8wub/6Bp2p7I/r/fZ8HewYcAR9p9LdMUUZ9kVRlecSc24p4GGXx1GqA7+7rvTePU6dpK6MPPErx8GyfxTA/SgNHk7MeZM0lLEnv15OUuyVuhYlzir8h39xBlL4VbruXJT4LK95/qnl/KydhC789nhhLy3Fn6uveRjghI5wMPXmaHYyxsA4ibcO9pIkAblGSZKAt0dp/jru1VbAYcwhkiQgoyhJEpBRlEI+CgA4ounQ9uBGMSAPabxCxFUiQC40CdAkAE0CNAlAkwBNAtAkQJMANAnQJABNAjQJQJMANAnQJABNAjQJQJMATQLQJECTADQJ0CQATQLQJECTADQJ0CQATQI0CUCTAE0C0CRAkwA0CdAkTQI0CUCTAE0C0CRAkwA0CThYk4ZBlABNAtAkQJMANAnQJABNAjQJQJMATQLQJECTADQJQJMATQLQJECTADQJ0CQATQI0CUCTAE0C0CQATQI0CUCTAE0C0CRAkwA0CdAkAE0CNAlAkwBNAtAkAE0CNAlAkwBNAtAkQJMANAnQJABNAjQJQJMANAnQJABNAjQJQJMATQLQJECTADQJ0CQATQI0SZMATQLQJECTADQJ0CQATQI0CUCTAE0C0CRAkwA0CUCTAE0C0CRAkwA0CdAkAE0CNAlAkwBNAtAkAE0CNAlAkwBNAtAkQJMANAnQJABNAjQJQJMATdIkQJMANAnQJABNAjQJQJMATQLQJECTADQJ0CQATQLQJECTADQJ0CQATQI0CUCTAE0C0CRAkwA0CUCTAE0C0CRAkwA0CdAkAE0CNAlAkwBNAtAkQJM0CdAkAE0CNAlAkwBNAtAkQJMANAnQJABNAjQJQJMANAnQJABNAjQJQJMATQLQJECTADQJ0CQATQLQJECTADQJ0CQATQI0CUCTAE0C0CRAkwA0CdAkAE0C0CRAkwA0CdAkAE0CNAlAkwBNAtAkQJMANAlAkwBNAtAkQJMANAnQJABNAjQJQJMATQLQJECTNAnQJABNAjQJQJMATQLQJECTADQJ0CQATQI0CUCTADQJ0CQATQI0CUCTAE0C0CRAkwA0CThjky6SBGgSgCYBmgSgSYAmAWgSoEkAmgRoEoAmAZoEoEkAmgRoEoAmAZoEoEmAJgFoEqBJAJoEaBKAJgFoEqBJAJoEaBKAJgGaBKBJgCYBaBKgSQCaBGgSgCYBaBKgSQCaBGgSgCYBmgSgSYAmAWgSoEkAmgSgSYAmAWgSoEkAmgRoEoAmAZoEoEmAJgFoEoAmAZoEoEmAJgFoEqBJAJoEaBKAJgGaBKBJgCYBaBKAJgGaBKBJgCYBaBKgSQCaBGgSgCYBmgSgSQCaBGgSgCYBmgSgSYAmAWgSoEkAmgRoEoAmAZqkSYAmAWgSoEkAmgRoEoAmAZoEoEmAJgFoEqBJAJoEoEmAJgFoEqBJAJoEaBKAJgGaBKBJgCYBaBKAJgGaBKBJgCYBaBKgSQCaBGgSgCYBmgSgSYAmaRKgSQCaBGgSgCYBmgSgSYAmAWgSoEkAmgRoEoAmAWgSoEkAmgRoEoAmAZoEfLJTBwIAAAAAQP6vjRChJ1VPqnpS9aSqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qepJ1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlT1pOpJVU+qnlT1pOpJVU+qnlT1pOpJVU+qelL1pKonXM0xlgAADTBJREFUVU+qelL1pKonVU+qelL1pKonVU+qelLVk6onVT2pelLVk6onVT2pelLVk6onVT2p6knVk6qeVD2p6knVk6qeVD2p6knVk6qeVD3pSdWTqp5UPanqSdWTqp5UPanqSdWTqp5UPanqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqp5U9aSqJ1VPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS9aQnVU+qelL1pKonVU+qelL1pKonVU+qelL1pKonVT2pelLVk6onVT2pelLVk6onVT2pelLVk6qeVD2p6knVk6qeVD2p6knVk6qeVD2p6knVk6qeVPWk6klVT6qeVPWk6klVT6qeVPWk6klVT6p6UvWkqidVT6p6UvWkqidVT6p6UvWkqidVPal6UtWTqidVPal6UtWTqidVPal6UtWTqidVPanqSdWTqp5UPanqSdWTqp5UPanqSdWTqp5U9aTqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqp70pOpJVU+qnlT1pOpJVU+qnlT1pOpJVU+qnlT1pKonVU+qelL1pKonVU+qelL1pKonVU+qelLVk6onVT2pelLVk6onVT2pelLVk6onVT2petKTqidVPal6UtWTqidVPal6UtWTqidVPal6UtWTqp5UPanqSdWTqp5UPanqSdWTqp5UPanqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS9aSqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlT1pOpJVU+qnlT1pOpJVU+qnlT1pOpJVU+qelL1pKonVU+qelL1pKonVU+qelL1pKonVU96UvWkqidVT6p6UvWkqidVT6p6UvWkqidVT6p6UtWTqidVPal6UtWTqidVPal6UtWTqidVPanqSdWTqp5UPanqSdWTqp5UPanqSdWTqp5UPelJ1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlQ9qepJVU+qnlT1pOpJVU+qnlT1pOpJVU+qnlT1pKonVU+qelL1pKonVU+qelL1pKonVU+qelL1pKonVT2pelLVk6onVT2pelLVk6onVT2pelLVk6qeVD2p6knVk6qeVD2p6knVk6qeVD2p6klVT6qeVPWk6klVT6qeVPWk6klVT6qeVPWk6klVT6p6UvWkqidVT6p6UvWkqidVT6p6UvWkqieFnToQAAAAAADyf22ECNWTqidVPal6UtWTqidVPal6UtWTqidVPal60pOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlQ9qepJVU+qnlT1pOpJVU+qnlT1pOpJVU+qnlT1pOpJT6qeVPWk6klVT6qeVPWk6klVT6qeVPWk6klVT6p6UvWkqidVT6p6UvWkqidVT6p6UvWkqidVPal6UtWTqidVPal6UtWTqidVPal6UtWTqidVPanqSdWTqp5UPanqSdWTqp5UPanqSdWTqp5U9aTqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS1ZOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qepJ1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlQ96UnVk6qeVD2p6knVk6qeVD2p6knVk6qeVD2p6klVT6qeVPWk6klVT6qeVPWk6klVT6qeVPWkqidVT6p6UvWkqidVT6p6UvWkqidVT6p6UvWkJ1VPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS9aSqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlQ9qepJ1ZOqnlT1pOpJVU+qnlT1pOpJVU+qnlT1pOpJVU+qelL1pKonVU+qelL1pKonVU+qelL1pKonVT2pelLVk6onVT2pelLVk6onVT2pelLVk6onVT2p6knVk6qeVD2p6knVk6qeVD2p6knVk6qeVPWk6klVT6qeVPWk6klVT6qeVPWk6klVT6qe9KTqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqp5U9aSqJ1VPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS1ZOqJ1U9qXpS1ZOqJ1U9qXpS1ZOqJ1U9qXrSk6onVT2pelLVk6onVT2pelLVk6onVT2pelLVk6qeVD2p6knVk6qeVD2p6knVk6qeVD2p6klVT6qeVPWk6klVT6qeVPWk6klVT6qeVPWk6klVT6p6UvWkqidVT6p6UvWkqidVT6p6UvWkqidVPal6UtWTqidVPal6UtWTqidVPal6UtWTqp5UPanqSdWTqp5UPanqSdWTqp5UPanqSdWTqp5U9aTqSVVPqp5U9aTqSVVPqp5U9aTqSVVPqnpS9aSqJ1VPqnpS9aSqJ1VPqnpS9aSqJ1VPelL1pKonVU+qelL1pKonVU+qelL1pKonVU+qelLVk6onVT2pelLVk6onVT2pelLVk6onVT2p6knVk6qeVD2p6knVk6qeVD2p6knVk6qeVD3pSdWTqp5UPanqSdWTqp5UPanqSdWTqp5UPanqSVVPqp5U9aTqSVXYqQMaAAAYBECvYP+yz6GDEDgJcBKAkwAnATgJcBKAkwCcBDgJwEmAkwCcBDgJwEmAkwCcBDgJwEmAkwCcBOAkwEkATgKcBOAkwEkATgKcBOAkwEkATgJwEuAkACcBTgJwEuAkACcBTgJwEuAkACcBOAlwEoCTACcBOAlwEoCTACcBOAlwEoCTACcBOAnASYCTAJwEOAnASYCTAJwEOAnASYCTAJwE4CTASQBOApwE4CTASQBOApwE4CTASQBOApzkJMBJAE4CnATgJMBJAE4CnATgJMBJAE4CnATgJAAnAU4CcBLgJAAnAU4CcBLgJAAnAU4CcBKAkwAnATgJcBKAkwAnATgJcBKAkwAnATgJcJKTACcBOAlwEoCTACcBOAlwEoCTACcBOAlwEoCTAJwEOAnASYCTAJwEOAnASYCTAJwEOAnASQBOApwE4CTASQBOApwE4CTASQBOApwE4CTASQBOAnAS4CQAJwF9JSVOApwE4CTASQBOApwE4CTASQBOApwE4CTASQBOAnAS4CQAJwFOAnAS4CQAJwFOAnAS4CQAJwE4CXASgJMAJwE4CXASgJMAJwE4CXASgJMAJzkJcBKAkwAnATgJcBKAkwAnATgJcBKAkwAnATgJwEmAkwCcBDgJwEmAkwCcBDgJwEmAkwCcBOAkwEkATgKcBOAkwEkATgKcBOAkwEkATgKcBOAkACcBTgJwEuAkACcBTgJwEuAkACcBTgJwEoCTACcBOAlwEoCTACcBOAlwEoCTACcBOAlwkpMAJwE4CXASgJMAJwE4CXASgJMAJwE4CXASgJMAnAQ4CcBJgJMAnAQ4CcBJgJMAnAQ4CcBJAE4CnATgJMBJAE4CnATgJMBJAE4CnATgJMBJTgKcBOAkwEkATgKcBOAkwEkATgKcBOAkwEkATgJwEuAkACcBTgJwEuAkACcBTgJwEuAkACcBOAlwEoCTACcBOAlwEoCTACcBOAlwEoCTACc5CXASgJMAJwE4CXASgJMAJwE4CZhP6ZwEOAnASYCTAJwEOAnASYCTAJwEOAnASYCTAJwE4CTASQBOApwE4CTASQBOApwE4CTASQBOAnAS4CQAJwFOAnAS4CQAJwFOAnAS4CQAJwFOchLgJAAnAU4CcBLgJAAnAU4CcBLgJAAnAU4CcBKAkwAnATgJcBKAkwAnATgJcBKAkwAnATgJwEmAkwCcBDgJwEmAkwCcBDgJwEmAkwCcBDgJwEkATgKcBOAkwEkATgKcBOAkwEkATgKcBOAkACcBTgJwEuAkACcBTgJwEuAkACcBTgJwEoCTACcBOAlwEoCTACcBOAlwEoCTACcBOAlwEoCTAJwEOAnASYCTAJwEOAnASYCTAJwEOAnASQBOApwE4CTASQBOApwE4CTg27t7ZQVhIACjDcOEIgXv/7I6Y6Pj+Auym/Wc8tph/AiBcDUJQJMATQLQJECTNAnQJABNAjQJQJOAcZvUmuMApHDJkSgBiZIkSkCqJIkSEG++DlHrsyMCRCap38yNJlECQpM03f5BlIBESRIlIFWSRAlIlSRRAlIl6RylVZSAoy3r8sVHAL+ZJT3rjigBaWZJogQkS9KLaRTAsUkSJeDIJL1xY+3hbTmAXb35AJIoAYmSJEpAqiSJEpAqSXdvMgHY2advbeu9sZXZZtkzvMG9WW+fbmVb2MwlcNmLDoN7O7trA3jWq+r36ufEoBavf6mYpO5Uw8DrDo5BOdYJMX5xngHzfFyPU3EIWw+tdZJx34Lhp/rdMSjE8x2ML+w/n1d+4O7vvkzYcbYftaS0FhZ1JW4xiRpLELMmlWiShyWxpKRJmZpkMYkyS0ohO5orNylo16ihTBUhexynwmJ2jRrIRzgBq/JnM/3SvXsAAAAASUVORK5CYII=)
    no-repeat;
  min-height: 1868px;
}

.scienceMain .demo_icon {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.scienceMain .content {
  position: absolute;
  left: 85px;
  top: 98px;
  text-align: center;
}

.scienceMain .content h2 {
  font-size: 24px;
  font-weight: 400;
  color: #d0b26c;
  line-height: 28px;
  margin: 0;
}

.scienceMain .content .itemBx {
  overflow: hidden;
}

.scienceMain .content .itemBx .item {
  float: left;
  width: 314px;
  height: 200px;
  border: 1px solid rgba(124, 99, 65, 0.92);
  background: pink;
  margin-top: 31px;
  margin-right: 29px;
  padding: 8px 22px;
  background: #40311c;
  box-sizing: border-box;
}

.scienceMain .content .itemBx .item h5 {
  font-size: 24px;
  font-weight: 700;
  color: #c79e4e;
  line-height: 48px;
  margin: 0 0 10px 0;
}

.scienceMain .content .itemBx .item p {
  width: 269px;
  font-size: 14px;
  font-weight: 400;
  color: #94701c;
  line-height: 24px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 5;
}

.m_app,
.m_banner,
.m_scienceMain {
  display: none;
}

@media screen and (max-width: 1170px) {
  .banner {
    display: none;
  }

  .m_banner,
  .m_scienceMain {
    display: block;
  }

  .scienceMain {
    background: url(data:image/png;base64,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)
      no-repeat;
  }

  .m_banner,
  .m_banner img {
    width: 100%;
  }

  .main {
    padding-top: 25px;
  }

  .m_header {
    background: transparent;
    text-align: center;
    padding-top: 50px;
  }

  .container .m_bg_none {
    display: none !important;
  }

  .main .mask {
    margin-top: 200px;
  }

  .banner h1 {
    font-size: 60px;
    color: #fff;
    font-weight: 600;
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -35%);
    white-space: nowrap;
  }

  .scienceMain .content {
    left: 35px;
  }

  .scienceMain .content .itemBx .item {
    width: 45.9%;
    height: 260px;
  }

  .scienceMain .content .itemBx .item h5 {
    font-size: 24px;
    color: #c79e4e;
  }

  .scienceMain .content .itemBx .item p {
    width: auto;
    font-size: 24px;
    line-height: 38px;
  }

  .demo_icon {
    display: none;
  }

  .scienceMain .content {
    top: 85px;
  }

  .scienceMain .content h2 {
    font-size: 32px;
    color: #d0b26c;
    margin-bottom: 20px;
  }

  .scienceMain {
    margin-top: 100px;
    background: url(data:image/png;base64,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)
      no-repeat;
    background-size: 80%;
    background-position: top;
    min-height: 3060px;
  }

  .app {
    position: relative;
    height: 25rem;
    background-position: 50%;
  }

  .app .science_bg,
  .app .science_bg_box {
    display: none;
  }

  .app .m_app {
    display: block;
    width: 42.5rem;
    height: 23.75rem;
    margin: auto;
  }

  .app .m_app img {
    display: block;
    height: 100%;
  }

  .app:after {
    top: 5.875rem;
  }

  .app:after,
  .app:before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 728px;
    height: 0.0625rem;
    background: #745c3c;
    left: 7.6875rem;
  }

  .app:before {
    bottom: -0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology.vue